export default "__VITE_ASSET__COVBVYa9__"